<template>
  <div class="container">
    <img src="@/assets/images/beijingSplit.png" />
    <div class="txtContent">
      <div class="text1">2024</div>
      <div class="text2">COMMEMORATIVE</div>
      <div class="text3">GENESIS</div>
      <div class="text4">Proof of NFT</div>
      <div class="num">#{{ num }}</div>
      <canvas ref="qrCanvas" class="canvas"></canvas>
      <div class="desc">（Scan Your NFT）</div>
      <div class="text5">DATE: December 31, 2024</div>
      <div class="text5">MATERIAL: Gold (surface)</div>
      <div class="text5 transform">Copper (inner)</div>
      <div class="text5">DIAMETER: 15.7inch</div>
      <div class="text5">WEIGHT: 0.06lbs</div>
      <div class="text5">
        CONTRACT: 0xbBb31cca79EAF1D005cA7173aacEcf1A548e73f4
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  name: "staticPage",
  data() {
    return {
      num: 0,
    };
  },
  methods: {
    async generateQRCode() {
      try {
        // 生成二维码到 canvas 元素
        await QRCode.toCanvas(this.$refs.qrCanvas, location.href, {
          width: 92,
          height: 92,
          margin: 1.2, // 二维码边距
        });
      } catch (err) {
        console.error("生成二维码时出错:", err);
      }
    },
    setRemUnit() {
      const docEl = document.documentElement;
      const clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      // 设计稿宽度为750px时，1rem = 100px
      const remUnit = 100 * (clientWidth / 750);
      docEl.style.fontSize = `${remUnit}px`;
    },
  },
  mounted() {
    if (location.hash.indexOf("?") >= 0) {
      this.num = location.hash.split("?")[1].split("=")[1] || 0;
    }
    this.generateQRCode();
    this.setRemUnit();
  },
};
</script>

<style scoped lang="scss">
.container {
  min-height: 100vh;
  background-color: #0b0a04;
  img {
    display: block;
    width: 100%;
    height: 7.23rem;
  }
  .txtContent {
    font-family: "Chusung", sans-serif;
    color: #ebcb6d;
    transform: translateY(-70px);
    text-align: center;
    .text1 {
      font-size: 1.2rem;
    }
    .text2 {
      font-size: 0.86rem;
    }
    .text3 {
      font-size: 0.86rem;
      color: #ffffff;
    }
    .text4 {
      font-size: 0.4rem;
    }
    .num {
      font-size: 1.04rem;
      color: #ffffff;
    }
    .canvas {
      width: 1.84rem;
      height: 1.84rem;
      background-color: #fff;
      margin-top: 16px;
    }
    .desc {
      font-size: 0.28rem;
      color: #ffffff;
      margin: 10px 0 16px;
    }
    .text5 {
      font-size: 0.32rem;
      margin-top: 5px;
    }
    .transform {
      margin-left: 1.56rem;
    }
  }
}
</style>
